module.exports = __webpack_public_path__ + "img/step1.161a3029.png";